<finxone-web-frontend-base-otp-verification
  [widgetConfig]="widgetConfig"
  [userProfileData]="userProfileData"
  [contentStyle]="contentStyle"
  [inputStyle]="inputStyle"
  [textContentStyle]="textContentStyle"
  [inputBaseStyle]="inputBaseStyle"
  [inputInactiveStyle]="inputInactiveStyle"
  [colorStyle]="colorStyle"
  [verifyButtonStyle]="verifyButtonStyle"
  [resendButtonStyle]="resendButtonStyle"
  [buttonContent]="buttonContent"
  [resendButtonContent]="resendButtonContent"
  [fieldValue]="fieldValue"
  [timerTextStyle]="timerTextStyle"
  [timerTextContent]="timerTextContent"
  (otpSubmitAndProcess)="handleOtpSubmitAndProcess($event)"
  [buttonGlobalStyles]="buttonGlobalStyles"
  (otpSubmissionHandler)="otpSubmissionHandler($event)"
></finxone-web-frontend-base-otp-verification>
